var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoginRoute)?_c('router-view'):_c('v-container',{class:_vm.isFullWidth ? 'pa-0' : 'pad',attrs:{"fluid":""}},[(_vm.isFullWidth)?[_c('router-view')]:_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"11","lg":"10"}},[_c('router-view')],1)],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }